// extracted by mini-css-extract-plugin
export default {"TrackCompetitors__itemlist":"fXjdZnZhOsDF46HVrczD","TrackCompetitors__item":"QhXhB3Nb8OvFTpa2c4If","TrackCompetitors__imgbox":"p6mksk8z_txPGS7GtaVQ","TrackCompetitors__image":"mbhHtiEFGFIKUf6gO9Gc","TrackCompetitors__textbox":"TSM5czllDr038ztSfpvc","HealthCheck__Btn":"_PJoO2LiSHSlerWUVamA","bluefill_animate":"BpTJNNI5K2R1Cch2Buyk","Popup__Btn":"gmdIXYlAAGKNk9ctCI7H","popup__subtitle":"na2YdcfqBycqBEszfpL2","pincodes_popup_Options":"WMAVGOV9DmvaBGYVLX3c"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"TrackCompetitors__itemlist\":\"fXjdZnZhOsDF46HVrczD\",\"TrackCompetitors__item\":\"QhXhB3Nb8OvFTpa2c4If\",\"TrackCompetitors__imgbox\":\"p6mksk8z_txPGS7GtaVQ\",\"TrackCompetitors__image\":\"mbhHtiEFGFIKUf6gO9Gc\",\"TrackCompetitors__textbox\":\"TSM5czllDr038ztSfpvc\",\"HealthCheck__Btn\":\"_PJoO2LiSHSlerWUVamA\",\"bluefill_animate\":\"BpTJNNI5K2R1Cch2Buyk\",\"Popup__Btn\":\"gmdIXYlAAGKNk9ctCI7H\",\"popup__subtitle\":\"na2YdcfqBycqBEszfpL2\",\"pincodes_popup_Options\":\"WMAVGOV9DmvaBGYVLX3c\"}";
        // 1750944248313
        var cssReload = require("../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  